import {
	registerThing,
	registerWeapon,
	registerMobFactory,
	registerThingClass,
	registerWeaponClass,
	registerItem,
} from "./serialization";
import { XY } from "./xy";
import { UnbreakableRock } from "./unbreakableRock";
import { Player } from "./player";
import { CannonBullet } from "./projectiles/cannonBullet";
import { Missile } from "./projectiles/missile";
import { Shrapnel } from "./projectiles/shrapnel";
import { SolidifierShot } from "./projectiles/solidifierShot";
import { Cannon } from "./weapons/cannon";
import { MissileGun } from "./weapons/missileGun";
import { Solidifier } from "./weapons/solidifier";
import { ShortSolidifierShot } from "./projectiles/shortSolidifierShot";
import { DrillBullet } from "./projectiles/drillBullet";
import { PlasmaBall } from "./projectiles/plasmaBall";
import { AirBlastShot } from "./projectiles/airBlastShot";
import { CryoShot } from "./projectiles/cryoShot";
import { BlackHoleProjectile } from "./projectiles/blackHoleProjectile";
import { BlackHoleGun } from "./weapons/blackHoleGun";
import { Punch } from "./weapons/punch";
import { MissileBurst } from "./weapons/missileBurst";
import { CannonBurst } from "./weapons/cannonBurst";
import { TripleSolidifier } from "./weapons/tripleSolidifier";
import { LaserGun } from "./weapons/laserGun";
import { DrillLauncher } from "./weapons/drillLauncher";
import { PlasmaGun } from "./weapons/plasmaGun";
import { AirBlast } from "./weapons/airBlast";
import { CryoGun } from "./weapons/cryoGun";
import { Jetpack } from "./weapons/jetpack";
import { Sword } from "./weapons/sword";
import { Cleaver } from "./weapons/cleaver";
import { SolidifiedSquid } from "./things/solidifiedSquid";
import { SolidifiedHorned } from "./things/solidifiedHorned";
import { SolidifiedBiter } from "./things/solidifiedBiter";
import { SolidifiedSlugant } from "./things/solidifiedSlugant";
import { BloodPool } from "./things/bloodPool";
import { BilePuddle } from "./things/bilePuddle";
import { ToxicSlugBrokenShell } from "./things/toxicSlugBrokenShell";
import { Squid } from "./mobs/squid";
import { Horned } from "./mobs/horned";
import { AlbinoSquid } from "./mobs/albinoSquid";
import { ArrowMob } from "./mobs/arrowMob";
import { Amoeba } from "./mobs/amoeba";
import { Biter } from "./mobs/biter";
import { SquidCorpse } from "./mobs/squidCorpse";
import { AlbinoSquidCorpse } from "./mobs/albinoSquidCorpse";
import { HornedCorpse } from "./mobs/hornedCorpse";
import { AmoebaCorpse } from "./mobs/amoebaCorpse";
import { BiterCorpse } from "./mobs/biterCorpse";
import { SlugantCorpse } from "./mobs/slugantCorpse";
import { RobotCorpse } from "./mobs/robotCorpse";
import { CaveRobotCorpse } from "./mobs/caveRobotCorpse";
import { FloatingRobotCorpse } from "./mobs/floatingRobotCorpse";
import { EngineerCorpse } from "./mobs/engineerCorpse";
import { DummyMob } from "./mobs/dummyMob";
import { DummyMobB } from "./mobs/dummyMobB";
import { DummyMobCorpse } from "./mobs/dummyMobCorpse";
import { EngineerRobot } from "./mobs/engineerRobot";
import { Slugant } from "./mobs/slugant";
import { ToxicSlug } from "./mobs/toxicSlug";
import { SnakeHead } from "./mobs/snakeHead";
import { SnakeBody } from "./mobs/snakeBody";
import { Robot } from "./mobs/robot";
import { CaveRobot } from "./mobs/caveRobot";
import { PlowRobot } from "./mobs/plowRobot";
import { BossPlowRobot } from "./mobs/bossPlowRobot";
import { BlackHoleRobot } from "./mobs/blackHoleRobot";
import { FloatingRobot } from "./mobs/floatingRobot";
import { JetpackMob } from "./mobs/jetpackMob";
import { RangedMobTest } from "./mobs/rangedMobTest";
import { HomingMissile } from "./things/homingMissile";

// Phase 4.5c: Floors
import { BlackFloor } from "./things/floors/blackFloor";
import { BoxFloor } from "./things/floors/boxFloor";
import { BrownFloor } from "./things/floors/brownFloor";
import { CaveFloor } from "./things/floors/caveFloor";
import { ConcreteFloor } from "./things/floors/concreteFloor";
import { DarkConcreteFloor } from "./things/floors/darkConcreteFloor";
import { GrassTiledFloor } from "./things/floors/grassTiledFloor";
import { GraySlab } from "./things/floors/graySlab";
import { GrayStoneFloor1 } from "./things/floors/grayStoneFloor1";
import { GrayStoneFloor2 } from "./things/floors/grayStoneFloor2";
import { MetalGridFloor } from "./things/floors/metalGridFloor";
import { MossFloor } from "./things/floors/mossFloor";
import { WarningFloor } from "./things/floors/warningFloor";
import { WoodenBridgeFloor } from "./things/floors/woodenBridgeFloor";
import { WoodenFloor } from "./things/floors/woodenFloor";
import { WavyTile } from "./things/floors/wavyTile";
import { TornGround } from "./things/floors/tornGround";
import { DustEmitter } from "./things/dustEmitter";

// Phase 4.5c: Visual remnants
import { Ashes } from "./things/ashes";
import { Tomb } from "./things/tomb";
import { DestroyedRock } from "./things/destroyedRock";
import { DestroyedConcreteBlock } from "./things/destroyedConcreteBlock";
import { DeadPlant } from "./things/deadPlant";

// Phase 4.5c: Destroyable obstacles
import { Rock } from "./things/rock";
import { CaveRock } from "./things/caveRock";
import { Sculpture1 } from "./things/sculpture1";
import { BrickWall } from "./things/brickWall";
import { Fence } from "./things/fence";
import { FenceLight } from "./things/fenceLight";
import { MossBrick } from "./things/mossBrick";
import { ScrapMetal } from "./things/scrapMetal";

// Phase 4.5c: ConcreteBlock + WallCrack
import { WallCrack } from "./things/wallCrack";
import { ConcreteBlock } from "./things/concreteBlock";

// Phase 4.5c: Indestructible obstacles
import { MetalBlock } from "./things/metalBlock";
import { MetalBlockDiagonal } from "./things/metalBlockDiagonal";
import { InvisibleWall } from "./things/invisibleWall";
import { BlackBox } from "./things/blackBox";
import { FireTower } from "./things/fireTower";

// Phase 4.5c: Barrels
import { EmptyBarrel } from "./things/emptyBarrel";
import { GasBarrel } from "./things/gasBarrel";
import { ExplosiveBarrel } from "./things/explosiveBarrel";

// Phase 4.5c: Furniture
import { OfficeChair } from "./things/officeChair";
import { WoodenDesk } from "./things/woodenDesk";
import { DeskWithComputer } from "./things/deskWithComputer";
import { DeskWithMachine } from "./things/deskWithMachine";
import { WoodenShelf } from "./things/woodenShelf";
import { WoodenCabinet } from "./things/woodenCabinet";
import { PlasticCabinet } from "./things/plasticCabinet";
import { MachineConnectedToWall } from "./things/machineConnectedToWall";
import { MachineRack } from "./things/machineRack";
import { LargeMachine } from "./things/largeMachine";
import { PottedPlant } from "./things/pottedPlant";
import { Sign } from "./things/sign";
import { VendingMachine } from "./things/vendingMachine";
import { PowerPlantSwitch } from "./things/powerPlantSwitch";
import { Lamp } from "./things/lamp";

// Phase 4.5c: Flora
import { Plant } from "./things/plant";
import { Tree } from "./things/tree";
import { Spreader } from "./things/spreader";
import { MossGate } from "./things/mossGate";

// Phase 4.5c: Environmental tiles
import { Chasm } from "./things/chasm";
import { LavaPool } from "./things/lavaPool";
import { WaterTile } from "./things/waterTile";

// Phase 4.5c: Smoke & Fire
import { Smoke } from "./things/smoke";
import { Fire } from "./things/fire";

// Phase 4.5c: Gas & Landmine
import { Gas } from "./things/gas";
import { BileGas } from "./things/bileGas";
import { Landmine } from "./things/landmine";

// Phase 4.5c: Doors
import { MetalDoor } from "./things/metalDoor";
import { BlastDoor } from "./things/blastDoor";
import { WoodenDoor } from "./things/woodenDoor";
import { SlidingDoor } from "./things/slidingDoor";
import { SlidingGate } from "./things/slidingGate";

// Phase 4.5c: Barrier
import { Barrier } from "./things/barrier";
import { BarrierGun } from "./weapons/barrierGun";

// Phase 4.5c: Level transitions
import { LevelUp } from "./things/levelUp";
import { LevelDown } from "./things/levelDown";
import { Upstairs } from "./things/upstairs";
import { Downstairs } from "./things/downstairs";
import { LadderUp } from "./things/ladderUp";
import { LadderDown } from "./things/ladderDown";

// GoldDrop
import { GoldDrop } from "./things/goldDrop";

// Phase 4.5c: LootBox
import { LootBox } from "./things/lootBox";
import { MetalLootBox } from "./things/metalLootBox";
import { KeyLootBox } from "./things/keyLootBox";
import { PowerPlantKeyCardLootBox } from "./things/powerPlantKeyCardLootBox";
import { BaseKeyCardLootBox } from "./things/baseKeyCardLootBox";
import { NightVisionLootBox } from "./things/nightVisionLootBox";
import { MedicalLootBox } from "./things/medicalLootBox";
import { RareItemsLootBox } from "./things/rareItemsLootBox";
import { JetpackLootBox } from "./things/jetpackLootBox";

// Phase 4.5c: Portal & Spawners
import { RobotSpawner } from "./things/robotSpawner";
import { RockMobCave } from "./things/rockMobCave";

// Phase 4.5c: Terminals & Traps
import { OpenBlastDoorsTerminal } from "./things/openBlastDoorsTerminal";
import { ZooReleaseTerminal } from "./things/zooReleaseTerminal";
import { PowerPlantGateTerminal } from "./things/powerPlantGateTerminal";
import { WinConditionTerminal } from "./things/winConditionTerminal";
import { RobotEntranceTerminal } from "./things/robotEntranceTerminal";
import { Trigger } from "./things/traps/trigger";
import { RobotActivationTrap } from "./things/traps/robotActivationTrap";
import { ActivateRobotSpawnersTrap } from "./things/traps/activateRobotSpawnersTrap";
import { OpenBlastDoorsTrap } from "./things/traps/openBlastDoorsTrap";
import { Tripwire } from "./things/traps/tripwire";

// Phase 4.5c: Special objects
import { Equation } from "./things/equation";
import { CycleDigit } from "./things/cycleDigit";
import { Text } from "./things/text";
import { WinArea } from "./things/winArea";

// Phase 4.5c: Entity weapons & projectiles
import { Flamethrower } from "./weapons/flamethrower";
import { RockGun } from "./weapons/rockGun";
import { GasBombWeapon } from "./weapons/gasBombWeapon";
import { GasBomb } from "./projectiles/gasBomb";
import { LandmineWeapon } from "./weapons/landmineWeapon";

registerThing(UnbreakableRock.key, UnbreakableRock.deserialize, UnbreakableRock);
registerThing(Player.key, Player.deserialize, Player);
registerThing(CannonBullet.key, CannonBullet.deserialize, CannonBullet);
registerThing(Missile.key, Missile.deserialize, Missile);
registerThing(Shrapnel.key, Shrapnel.deserialize, Shrapnel);
registerThing(SolidifierShot.key, SolidifierShot.deserialize, SolidifierShot);
registerThing(SolidifiedSquid.key, SolidifiedSquid.deserialize, SolidifiedSquid);
registerThing(SolidifiedHorned.key, SolidifiedHorned.deserialize, SolidifiedHorned);
registerThing(Squid.key, Squid.deserialize, Squid);
registerThing(Horned.key, Horned.deserialize, Horned);
registerThing(AlbinoSquid.key, AlbinoSquid.deserialize, AlbinoSquid);
registerThing(ArrowMob.key, ArrowMob.deserialize, ArrowMob);
registerThing(Amoeba.key, Amoeba.deserialize, Amoeba);
registerThing(Biter.key, Biter.deserialize, Biter);
registerThing(SolidifiedBiter.key, SolidifiedBiter.deserialize, SolidifiedBiter);
registerThing(SolidifiedSlugant.key, SolidifiedSlugant.deserialize, SolidifiedSlugant);
registerThing(BloodPool.key, BloodPool.deserialize, BloodPool);
registerThing(BilePuddle.key, BilePuddle.deserialize, BilePuddle);
registerThing(ToxicSlugBrokenShell.key, ToxicSlugBrokenShell.deserialize, ToxicSlugBrokenShell);
registerThing(SquidCorpse.key, SquidCorpse.deserialize, SquidCorpse);
registerThing(AlbinoSquidCorpse.key, AlbinoSquidCorpse.deserialize, AlbinoSquidCorpse);
registerThing(HornedCorpse.key, HornedCorpse.deserialize, HornedCorpse);
registerThing(AmoebaCorpse.key, AmoebaCorpse.deserialize, AmoebaCorpse);
registerThing(BiterCorpse.key, BiterCorpse.deserialize, BiterCorpse);
registerThing(SlugantCorpse.key, SlugantCorpse.deserialize, SlugantCorpse);
registerThing(RobotCorpse.key, RobotCorpse.deserialize, RobotCorpse);
registerThing(CaveRobotCorpse.key, CaveRobotCorpse.deserialize, CaveRobotCorpse);
registerThing(FloatingRobotCorpse.key, FloatingRobotCorpse.deserialize, FloatingRobotCorpse);
registerThing(EngineerCorpse.key, EngineerCorpse.deserialize, EngineerCorpse);
registerThing(DummyMob.key, DummyMob.deserialize, DummyMob);
registerThing(DummyMobB.key, DummyMobB.deserialize, DummyMobB);
registerThing(DummyMobCorpse.key, DummyMobCorpse.deserialize, DummyMobCorpse);
registerThing(Slugant.key, Slugant.deserialize, Slugant);
registerThing(ToxicSlug.key, ToxicSlug.deserialize, ToxicSlug);
registerThing(SnakeHead.key, SnakeHead.deserialize, SnakeHead);
registerThing(SnakeBody.key, SnakeBody.deserialize, SnakeBody);
registerThing(Robot.key, Robot.deserialize, Robot);
registerThing(CaveRobot.key, CaveRobot.deserialize, CaveRobot);
registerThing(PlowRobot.key, PlowRobot.deserialize, PlowRobot);
registerThing(BossPlowRobot.key, BossPlowRobot.deserialize, BossPlowRobot);
registerThing(BlackHoleRobot.key, BlackHoleRobot.deserialize, BlackHoleRobot);
registerThing(FloatingRobot.key, FloatingRobot.deserialize, FloatingRobot);
registerThing(EngineerRobot.key, EngineerRobot.deserialize, EngineerRobot);
registerThing(JetpackMob.key, JetpackMob.deserialize, JetpackMob);
registerThing(RangedMobTest.key, RangedMobTest.deserialize, RangedMobTest);
registerThing(HomingMissile.key, HomingMissile.deserialize, HomingMissile);
registerThing(ShortSolidifierShot.key, ShortSolidifierShot.deserialize, ShortSolidifierShot);
registerThing(DrillBullet.key, DrillBullet.deserialize, DrillBullet);
registerThing(PlasmaBall.key, PlasmaBall.deserialize, PlasmaBall);
registerThing(AirBlastShot.key, AirBlastShot.deserialize, AirBlastShot);
registerThing(CryoShot.key, CryoShot.deserialize, CryoShot);
registerThing(BlackHoleProjectile.key, BlackHoleProjectile.deserialize, BlackHoleProjectile);

registerWeapon(Cannon.key, Cannon.deserialize);
registerWeaponClass(Cannon.key, Cannon);
registerWeapon(MissileGun.key, MissileGun.deserialize);
registerWeaponClass(MissileGun.key, MissileGun);
registerWeapon(Solidifier.key, Solidifier.deserialize);
registerWeaponClass(Solidifier.key, Solidifier);
registerWeapon(Punch.key, Punch.deserialize);
registerWeaponClass(Punch.key, Punch);
registerWeapon(MissileBurst.key, MissileBurst.deserialize);
registerWeaponClass(MissileBurst.key, MissileBurst);
registerWeapon(CannonBurst.key, CannonBurst.deserialize);
registerWeaponClass(CannonBurst.key, CannonBurst);
registerWeapon(TripleSolidifier.key, TripleSolidifier.deserialize);
registerWeaponClass(TripleSolidifier.key, TripleSolidifier);
registerWeapon(LaserGun.key, LaserGun.deserialize);
registerWeaponClass(LaserGun.key, LaserGun);
registerWeapon(DrillLauncher.key, DrillLauncher.deserialize);
registerWeaponClass(DrillLauncher.key, DrillLauncher);
registerWeapon(PlasmaGun.key, PlasmaGun.deserialize);
registerWeaponClass(PlasmaGun.key, PlasmaGun);
registerWeapon(AirBlast.key, AirBlast.deserialize);
registerWeaponClass(AirBlast.key, AirBlast);
registerWeapon(CryoGun.key, CryoGun.deserialize);
registerWeaponClass(CryoGun.key, CryoGun);
registerWeapon(Jetpack.key, Jetpack.deserialize);
registerWeaponClass(Jetpack.key, Jetpack);
registerWeapon(Sword.key, Sword.deserialize);
registerWeaponClass(Sword.key, Sword);
registerWeapon(Cleaver.key, Cleaver.deserialize);
registerWeaponClass(Cleaver.key, Cleaver);
registerWeapon(BlackHoleGun.key, BlackHoleGun.deserialize);
registerWeaponClass(BlackHoleGun.key, BlackHoleGun);

// Phase 4.5c: Floors
registerThing(BlackFloor.key, BlackFloor.deserialize, BlackFloor);
registerThing(BoxFloor.key, BoxFloor.deserialize, BoxFloor);
registerThing(BrownFloor.key, BrownFloor.deserialize, BrownFloor);
registerThing(CaveFloor.key, CaveFloor.deserialize, CaveFloor);
registerThing(ConcreteFloor.key, ConcreteFloor.deserialize, ConcreteFloor);
registerThing(DarkConcreteFloor.key, DarkConcreteFloor.deserialize, DarkConcreteFloor);
registerThing(GrassTiledFloor.key, GrassTiledFloor.deserialize, GrassTiledFloor);
registerThing(GraySlab.key, GraySlab.deserialize, GraySlab);
registerThing(GrayStoneFloor1.key, GrayStoneFloor1.deserialize, GrayStoneFloor1);
registerThing(GrayStoneFloor2.key, GrayStoneFloor2.deserialize, GrayStoneFloor2);
registerThing(MetalGridFloor.key, MetalGridFloor.deserialize, MetalGridFloor);
registerThing(MossFloor.key, MossFloor.deserialize, MossFloor);
registerThing(WarningFloor.key, WarningFloor.deserialize, WarningFloor);
registerThing(WoodenBridgeFloor.key, WoodenBridgeFloor.deserialize, WoodenBridgeFloor);
registerThing(WoodenFloor.key, WoodenFloor.deserialize, WoodenFloor);
registerThing(WavyTile.key, WavyTile.deserialize, WavyTile);
registerThing(TornGround.key, TornGround.deserialize, TornGround);
registerThing(DustEmitter.key, DustEmitter.deserialize, DustEmitter);

// Phase 4.5c: Visual remnants
registerThing(Ashes.key, Ashes.deserialize, Ashes);
registerThing(Tomb.key, Tomb.deserialize, Tomb);
registerThing(DestroyedRock.key, DestroyedRock.deserialize, DestroyedRock);
registerThing(DestroyedConcreteBlock.key, DestroyedConcreteBlock.deserialize, DestroyedConcreteBlock);
registerThing(DeadPlant.key, DeadPlant.deserialize, DeadPlant);

// Phase 4.5c: Destroyable obstacles
registerThing(Rock.key, Rock.deserialize, Rock);
registerThing(CaveRock.key, CaveRock.deserialize, CaveRock);
registerThing(Sculpture1.key, Sculpture1.deserialize, Sculpture1);
registerThing(BrickWall.key, BrickWall.deserialize, BrickWall);
registerThing(Fence.key, Fence.deserialize, Fence);
registerThing(FenceLight.key, FenceLight.deserialize, FenceLight);
registerThing(MossBrick.key, MossBrick.deserialize, MossBrick);
registerThing(ScrapMetal.key, ScrapMetal.deserialize, ScrapMetal);

// Phase 4.5c: ConcreteBlock + WallCrack
registerThing(WallCrack.key, WallCrack.deserialize, WallCrack);
registerThing(ConcreteBlock.key, ConcreteBlock.deserialize, ConcreteBlock);

// Phase 4.5c: Indestructible obstacles
registerThing(MetalBlock.key, MetalBlock.deserialize, MetalBlock);
registerThing(MetalBlockDiagonal.key, MetalBlockDiagonal.deserialize, MetalBlockDiagonal);
registerThing(InvisibleWall.key, InvisibleWall.deserialize, InvisibleWall);
registerThing(BlackBox.key, BlackBox.deserialize, BlackBox);
registerThing(FireTower.key, FireTower.deserialize, FireTower);

// Phase 4.5c: Barrels
registerThing(EmptyBarrel.key, EmptyBarrel.deserialize, EmptyBarrel);
registerThing(GasBarrel.key, GasBarrel.deserialize, GasBarrel);
registerThing(ExplosiveBarrel.key, ExplosiveBarrel.deserialize, ExplosiveBarrel);

// Phase 4.5c: Furniture
registerThing(OfficeChair.key, OfficeChair.deserialize, OfficeChair);
registerThing(WoodenDesk.key, WoodenDesk.deserialize, WoodenDesk);
registerThing(DeskWithComputer.key, DeskWithComputer.deserialize, DeskWithComputer);
registerThing(DeskWithMachine.key, DeskWithMachine.deserialize, DeskWithMachine);
registerThing(WoodenShelf.key, WoodenShelf.deserialize, WoodenShelf);
registerThing(WoodenCabinet.key, WoodenCabinet.deserialize, WoodenCabinet);
registerThing(PlasticCabinet.key, PlasticCabinet.deserialize, PlasticCabinet);
registerThing(MachineConnectedToWall.key, MachineConnectedToWall.deserialize, MachineConnectedToWall);
registerThing(MachineRack.key, MachineRack.deserialize, MachineRack);
registerThing(LargeMachine.key, LargeMachine.deserialize, LargeMachine);
registerThing(PottedPlant.key, PottedPlant.deserialize, PottedPlant);
registerThing(Sign.key, Sign.deserialize, Sign);
registerThing(VendingMachine.key, VendingMachine.deserialize, VendingMachine);
registerThing(PowerPlantSwitch.key, PowerPlantSwitch.deserialize, PowerPlantSwitch);
registerThing(Lamp.key, Lamp.deserialize, Lamp);

// Phase 4.5c: Flora
registerThing(Plant.key, Plant.deserialize, Plant);
registerThing(Tree.key, Tree.deserialize, Tree);
registerThing(Spreader.key, Spreader.deserialize, Spreader);
registerThing(MossGate.key, MossGate.deserialize, MossGate);

// Phase 4.5c: Environmental tiles
registerThing(Chasm.key, Chasm.deserialize, Chasm);
registerThing(LavaPool.key, LavaPool.deserialize, LavaPool);
registerThing(WaterTile.key, WaterTile.deserialize, WaterTile);

// Phase 4.5c: Smoke & Fire
registerThing(Smoke.key, Smoke.deserialize, Smoke);
registerThing(Fire.key, Fire.deserialize, Fire);

// Phase 4.5c: Gas & Landmine
registerThing(Gas.key, Gas.deserialize, Gas);
registerThing(BileGas.key, BileGas.deserialize, BileGas);
registerThing(Landmine.key, Landmine.deserialize, Landmine);

// Phase 4.5c: Doors
registerThing(MetalDoor.key, MetalDoor.deserialize, MetalDoor);
registerThing(BlastDoor.key, BlastDoor.deserialize, BlastDoor);
registerThing(WoodenDoor.key, WoodenDoor.deserialize, WoodenDoor);
registerThing(SlidingDoor.key, SlidingDoor.deserialize, SlidingDoor);
registerThing(SlidingGate.key, SlidingGate.deserialize, SlidingGate);

// Phase 4.5c: Barrier
registerThing(Barrier.key, Barrier.deserialize, Barrier);

// Phase 4.5c: Level transitions
registerThing(LevelUp.key, LevelUp.deserialize, LevelUp);
registerThing(LevelDown.key, LevelDown.deserialize, LevelDown);
registerThing(Upstairs.key, Upstairs.deserialize, Upstairs);
registerThing(Downstairs.key, Downstairs.deserialize, Downstairs);
registerThing(LadderUp.key, LadderUp.deserialize, LadderUp);
registerThing(LadderDown.key, LadderDown.deserialize, LadderDown);

// GoldDrop
registerThing(GoldDrop.key, GoldDrop.deserialize, GoldDrop);

// Phase 4.5c: LootBox
registerThing(LootBox.key, LootBox.deserialize, LootBox);
registerThing(MetalLootBox.key, MetalLootBox.deserialize, MetalLootBox);
registerThing(KeyLootBox.key, KeyLootBox.deserialize, KeyLootBox);
registerThing(PowerPlantKeyCardLootBox.key, PowerPlantKeyCardLootBox.deserialize, PowerPlantKeyCardLootBox);
registerThing(BaseKeyCardLootBox.key, BaseKeyCardLootBox.deserialize, BaseKeyCardLootBox);
registerThing(NightVisionLootBox.key, NightVisionLootBox.deserialize, NightVisionLootBox);
registerThing(MedicalLootBox.key, MedicalLootBox.deserialize, MedicalLootBox);
registerThing(RareItemsLootBox.key, RareItemsLootBox.deserialize, RareItemsLootBox);
registerThing(JetpackLootBox.key, JetpackLootBox.deserialize, JetpackLootBox);

// Phase 4.5c: Portal & Spawners
registerThing(RobotSpawner.key, RobotSpawner.deserialize, RobotSpawner);
registerThing(RockMobCave.key, RockMobCave.deserialize, RockMobCave);

// Phase 4.5c: Terminals & Traps
registerThing(OpenBlastDoorsTerminal.key, OpenBlastDoorsTerminal.deserialize, OpenBlastDoorsTerminal);
registerThing(PowerPlantGateTerminal.key, PowerPlantGateTerminal.deserialize, PowerPlantGateTerminal);
registerThing(WinConditionTerminal.key, WinConditionTerminal.deserialize, WinConditionTerminal);
registerThing(RobotEntranceTerminal.key, RobotEntranceTerminal.deserialize, RobotEntranceTerminal);
registerThing(ZooReleaseTerminal.key, ZooReleaseTerminal.deserialize, ZooReleaseTerminal);
registerThing(Trigger.key, Trigger.deserialize, Trigger);
registerThing(RobotActivationTrap.key, RobotActivationTrap.deserialize, RobotActivationTrap);
registerThing(ActivateRobotSpawnersTrap.key, ActivateRobotSpawnersTrap.deserialize, ActivateRobotSpawnersTrap);
registerThing(OpenBlastDoorsTrap.key, OpenBlastDoorsTrap.deserialize, OpenBlastDoorsTrap);
registerThing(Tripwire.key, Tripwire.deserialize, Tripwire);

// Phase 4.5c: Special objects
registerThing(Equation.key, Equation.deserialize, Equation);
registerThing(CycleDigit.key, CycleDigit.deserialize, CycleDigit);
registerThing(Text.key, Text.deserialize, Text);
registerThing(WinArea.key, WinArea.deserialize, WinArea);

// Phase 4.5c: Entity weapons & projectiles
registerThing(GasBomb.key, GasBomb.deserialize, GasBomb);
registerWeapon(BarrierGun.key, BarrierGun.deserialize);
registerWeaponClass(BarrierGun.key, BarrierGun);
registerWeapon(Flamethrower.key, Flamethrower.deserialize);
registerWeaponClass(Flamethrower.key, Flamethrower);
registerWeapon(RockGun.key, RockGun.deserialize);
registerWeaponClass(RockGun.key, RockGun);
registerWeapon(GasBombWeapon.key, GasBombWeapon.deserialize);
registerWeaponClass(GasBombWeapon.key, GasBombWeapon);
registerWeapon(LandmineWeapon.key, LandmineWeapon.deserialize);
registerWeaponClass(LandmineWeapon.key, LandmineWeapon);

// Phase 4.5d: Multi-tile
import { MultiTileThingPart } from "./things/multitile/multiTileThingPart";
registerThing(MultiTileThingPart.key, MultiTileThingPart.deserialize, MultiTileThingPart);

// Phase 4.5d: BigContainer
import { BigContainer } from "./things/bigContainer";
registerThing(BigContainer.key, BigContainer.deserialize, BigContainer);

// Phase 4.5d: Portal2
import { Portal2 } from "./things/portal2/portal2";
import { Portal2Part } from "./things/portal2/portal2Part";
import { ReinforcedPortal2 } from "./things/portal2/reinforcedPortal2";
registerThing(Portal2.key, Portal2.deserialize, Portal2);
registerThing(Portal2Part.key, Portal2Part.deserialize, Portal2Part);
registerThing(ReinforcedPortal2.key, ReinforcedPortal2.deserialize, ReinforcedPortal2);

// Phase 4.5d: LevelDirector
import { LevelDirector } from "./things/levelDirector";
registerThing(LevelDirector.key, LevelDirector.deserialize, LevelDirector);

import { ScheduledHint } from "./things/scheduledHint";
registerThing(ScheduledHint.key, ScheduledHint.deserialize, ScheduledHint);

// Arrival handlers
import { CorpseCleanerOnArrival } from "./things/corpseCleanerOnArrival";
registerThing(CorpseCleanerOnArrival.key, CorpseCleanerOnArrival.deserialize, CorpseCleanerOnArrival);
import { PowerPlantLightsOnArrival } from "./things/powerPlantLightsOnArrival";
registerThing(PowerPlantLightsOnArrival.key, PowerPlantLightsOnArrival.deserialize, PowerPlantLightsOnArrival);
import { PowerPlantGateOnArrival } from "./things/powerPlantGateOnArrival";
registerThing(PowerPlantGateOnArrival.key, PowerPlantGateOnArrival.deserialize, PowerPlantGateOnArrival);

// Phase 4.5d: BigSquid
import { BigSquid } from "./mobs/bigSquid";
import { BigSquidTentacle } from "./mobs/bigSquidTentacle";
import { BigSquidTentacleCut } from "./mobs/bigSquidTentacleCut";
import { BigSquidCorpse } from "./mobs/bigSquidCorpse";
import { BigSquidTentacleCorpse } from "./mobs/bigSquidTentacleCorpse";
registerThing(BigSquid.key, BigSquid.deserialize, BigSquid);
registerThing(BigSquidTentacle.key, BigSquidTentacle.deserialize, BigSquidTentacle);
registerThing(BigSquidTentacleCut.key, BigSquidTentacleCut.deserialize, BigSquidTentacleCut);
registerThing(BigSquidCorpse.key, BigSquidCorpse.deserialize, BigSquidCorpse);
registerThing(BigSquidTentacleCorpse.key, BigSquidTentacleCorpse.deserialize, BigSquidTentacleCorpse);

// Phase 4.5d: HeavyRobot & MiningRobot
import { HeavyRobot } from "./mobs/heavyRobot";
import { HeavyRobotPart } from "./mobs/heavyRobotPart";
import { MiningRobot } from "./things/miningRobot";
registerThing(HeavyRobot.key, HeavyRobot.deserialize, HeavyRobot);
registerThing(HeavyRobotPart.key, HeavyRobotPart.deserialize, HeavyRobotPart);
registerThing(MiningRobot.key, MiningRobot.deserialize, MiningRobot);

// Phase 4.5d: Dev weapons & helpers
import { DevGunAutoKillBot } from "./things/devGunAutoKillBot";
import { ArtilleryAimIndicator } from "./things/artilleryAimIndicator";
import { ArtilleryBomb } from "./things/artilleryBomb";
import { ArtilleryRobot } from "./things/artilleryRobot";
import { OpGun } from "./weapons/opGun";
import { OpGun2 } from "./weapons/opGun2";
import { OpGunNuke } from "./weapons/opGunNuke";
import { DevGunAutoKill } from "./weapons/devGunAutoKill";
import { DebugRemoteControl } from "./weapons/debugRemoteControl";
registerThing(DevGunAutoKillBot.key, DevGunAutoKillBot.deserialize, DevGunAutoKillBot);
registerThing(ArtilleryAimIndicator.key, ArtilleryAimIndicator.deserialize, ArtilleryAimIndicator);
registerThing(ArtilleryBomb.key, ArtilleryBomb.deserialize, ArtilleryBomb);

// Phase 5a: ArtilleryRobot
registerThing(ArtilleryRobot.key, ArtilleryRobot.deserialize, ArtilleryRobot);

// Phase 5e: DebugIndicator
import { DebugIndicator } from "./things/debugIndicator";
registerThing(DebugIndicator.key, DebugIndicator.deserialize, DebugIndicator);

import { MapMarker } from "./things/mapMarker";
registerThing(MapMarker.key, MapMarker.deserialize, MapMarker);

// Dev/QA fixture for visualizing effects (playground only). Edit its processTurn
// to swap out which effect is currently being inspected.
import { EffectTester } from "./things/effectTester";
registerThing(EffectTester.key, EffectTester.deserialize, EffectTester);
registerWeapon(OpGun.key, OpGun.deserialize);
registerWeaponClass(OpGun.key, OpGun);
registerWeapon(OpGun2.key, OpGun2.deserialize);
registerWeaponClass(OpGun2.key, OpGun2);
registerWeapon(OpGunNuke.key, OpGunNuke.deserialize);
registerWeaponClass(OpGunNuke.key, OpGunNuke);
registerWeapon(DevGunAutoKill.key, DevGunAutoKill.deserialize);
registerWeaponClass(DevGunAutoKill.key, DevGunAutoKill);
registerWeapon(DebugRemoteControl.key, DebugRemoteControl.deserialize);
registerWeaponClass(DebugRemoteControl.key, DebugRemoteControl);

// Collectable items
import { Ammo } from "./items/ammo";
import { Gold } from "./items/gold";
import { Key } from "./items/key";
import { Medikit } from "./items/medikit";
import { PowerPlantKeyCard } from "./items/powerPlantKeyCard";
import { BaseKeyCard } from "./items/baseKeyCard";
import { NightVisionEquipment } from "./items/nightVisionEquipment";
registerItem(Ammo.key, Ammo.deserialize);
registerItem(Gold.key, Gold.deserialize);
registerItem(Key.key, Key.deserialize);
registerItem(Medikit.key, Medikit.deserialize);
registerItem(PowerPlantKeyCard.key, PowerPlantKeyCard.deserialize);
registerItem(BaseKeyCard.key, BaseKeyCard.deserialize);
registerItem(NightVisionEquipment.key, NightVisionEquipment.deserialize);

// Phase 5g: Tutorial entities
import { TimedAction } from "./things/tutorial/timedAction";
import { PlayerOnTileAction } from "./things/tutorial/playerOnTileAction";
import { PlayerReachableAction } from "./things/tutorial/playerReachableAction";
import { PlayerHasAmmoAction } from "./things/tutorial/playerHasAmmoAction";
import { PlayerOutOfAmmoAction } from "./things/tutorial/playerOutOfAmmoAction";
import { ThingDestroyedAction } from "./things/tutorial/thingDestroyedAction";
import { NoMobsInAreaAction } from "./things/tutorial/noMobsInAreaAction";
import { NoThreatsAction } from "./things/tutorial/noThreatsAction";
import { ArrowDisplay } from "./things/tutorial/arrowDisplay";
import { FloatingArrow } from "./things/tutorial/floatingArrow";
import { InvulnerableBigContainer } from "./things/tutorial/invulnerableBigContainer";
registerThing(TimedAction.key, TimedAction.deserialize, TimedAction);
registerThing(PlayerOnTileAction.key, PlayerOnTileAction.deserialize, PlayerOnTileAction);
registerThing(PlayerReachableAction.key, PlayerReachableAction.deserialize, PlayerReachableAction);
registerThing(PlayerHasAmmoAction.key, PlayerHasAmmoAction.deserialize, PlayerHasAmmoAction);
registerThing(PlayerOutOfAmmoAction.key, PlayerOutOfAmmoAction.deserialize, PlayerOutOfAmmoAction);
registerThing(ThingDestroyedAction.key, ThingDestroyedAction.deserialize, ThingDestroyedAction);
registerThing(NoMobsInAreaAction.key, NoMobsInAreaAction.deserialize, NoMobsInAreaAction);
registerThing(NoThreatsAction.key, NoThreatsAction.deserialize, NoThreatsAction);
registerThing(ArrowDisplay.key, ArrowDisplay.deserialize, ArrowDisplay);
registerThing(FloatingArrow.key, FloatingArrow.deserialize, FloatingArrow);
registerThing(InvulnerableBigContainer.key, InvulnerableBigContainer.deserialize, InvulnerableBigContainer);

// Mob factories — used by MobSpawnerConfig to recreate mob suppliers after deserialization
const PH = new XY(0, 0);
registerMobFactory(Squid.key, () => new Squid(PH));
registerMobFactory(AlbinoSquid.key, () => new AlbinoSquid(PH));
registerMobFactory(Horned.key, () => new Horned(PH));
registerMobFactory(Slugant.key, () => new Slugant(PH));
registerMobFactory(ToxicSlug.key, () => new ToxicSlug(PH));
registerMobFactory(Biter.key, () => new Biter(PH));
registerMobFactory(Robot.key, () => new Robot(PH));
registerMobFactory(CaveRobot.key, () => new CaveRobot(PH));
registerMobFactory(PlowRobot.key, () => new PlowRobot(PH));
registerMobFactory(BossPlowRobot.key, () => new BossPlowRobot(PH));
registerMobFactory(FloatingRobot.key, () => new FloatingRobot(PH));
registerMobFactory(EngineerRobot.key, () => new EngineerRobot(PH));
registerMobFactory(JetpackMob.key, () => new JetpackMob(PH));
registerMobFactory(DummyMob.key, () => new DummyMob(PH));
registerMobFactory(DummyMobB.key, () => new DummyMobB(PH));

// Entity class registry — used by prefab builder to resolve legend class names
// Floors
registerThingClass(ConcreteFloor.key, ConcreteFloor);
registerThingClass(DarkConcreteFloor.key, DarkConcreteFloor);
registerThingClass(GrayStoneFloor1.key, GrayStoneFloor1);
registerThingClass(GrayStoneFloor2.key, GrayStoneFloor2);
registerThingClass(WarningFloor.key, WarningFloor);
registerThingClass(BrownFloor.key, BrownFloor);
registerThingClass(CaveFloor.key, CaveFloor);
registerThingClass(GraySlab.key, GraySlab);
registerThingClass(WoodenBridgeFloor.key, WoodenBridgeFloor);
registerThingClass(WoodenFloor.key, WoodenFloor);
registerThingClass(WavyTile.key, WavyTile);
registerThingClass(TornGround.key, TornGround);
registerThingClass(DustEmitter.key, DustEmitter);
registerThingClass(GrassTiledFloor.key, GrassTiledFloor);
registerThingClass(MossFloor.key, MossFloor);
registerThingClass(BlackFloor.key, BlackFloor);
registerThingClass(BoxFloor.key, BoxFloor);
registerThingClass(MetalGridFloor.key, MetalGridFloor);

// Walls/Obstacles
registerThingClass(UnbreakableRock.key, UnbreakableRock);
registerThingClass(MetalBlock.key, MetalBlock);
registerThingClass(ConcreteBlock.key, ConcreteBlock);
registerThingClass(MossBrick.key, MossBrick);
registerThingClass(Fence.key, Fence);
registerThingClass(FenceLight.key, FenceLight);
registerThingClass(BrickWall.key, BrickWall);
registerThingClass(Rock.key, Rock);
registerThingClass(CaveRock.key, CaveRock);
registerThingClass(Sculpture1.key, Sculpture1);
registerThingClass(MetalBlockDiagonal.key, MetalBlockDiagonal);
registerThingClass(InvisibleWall.key, InvisibleWall);

// Doors
registerThingClass(WoodenDoor.key, WoodenDoor);
registerThingClass(MetalDoor.key, MetalDoor);
registerThingClass(BlastDoor.key, BlastDoor);
registerThingClass(SlidingDoor.key, SlidingDoor);
registerThingClass(SlidingGate.key, SlidingGate);
registerThingClass(MossGate.key, MossGate);

// Destroyable/Furniture
registerThingClass(WoodenDesk.key, WoodenDesk);
registerThingClass(DeskWithComputer.key, DeskWithComputer);
registerThingClass(DeskWithMachine.key, DeskWithMachine);
registerThingClass(OfficeChair.key, OfficeChair);
registerThingClass(WoodenShelf.key, WoodenShelf);
registerThingClass(WoodenCabinet.key, WoodenCabinet);
registerThingClass(PlasticCabinet.key, PlasticCabinet);
registerThingClass(MachineRack.key, MachineRack);
registerThingClass(LargeMachine.key, LargeMachine);
registerThingClass(MachineConnectedToWall.key, MachineConnectedToWall);
registerThingClass(VendingMachine.key, VendingMachine);
registerThingClass(PowerPlantSwitch.key, PowerPlantSwitch);
registerThingClass(Lamp.key, Lamp);
registerThingClass(Barrier.key, Barrier);

// Barrels
registerThingClass(EmptyBarrel.key, EmptyBarrel);
registerThingClass(GasBarrel.key, GasBarrel);
registerThingClass(ExplosiveBarrel.key, ExplosiveBarrel);

// Loot
registerThingClass(LootBox.key, LootBox);
registerThingClass(MetalLootBox.key, MetalLootBox);
registerThingClass(MedicalLootBox.key, MedicalLootBox);
registerThingClass(KeyLootBox.key, KeyLootBox);
registerThingClass(PowerPlantKeyCardLootBox.key, PowerPlantKeyCardLootBox);
registerThingClass(BaseKeyCardLootBox.key, BaseKeyCardLootBox);
registerThingClass(NightVisionLootBox.key, NightVisionLootBox);
registerThingClass(RareItemsLootBox.key, RareItemsLootBox);
registerThingClass(JetpackLootBox.key, JetpackLootBox);
registerThingClass(GoldDrop.key, GoldDrop);

// Plants
registerThingClass(PottedPlant.key, PottedPlant);
registerThingClass(Plant.key, Plant);
registerThingClass(DeadPlant.key, DeadPlant);
registerThingClass(Tree.key, Tree);

// Hazards
registerThingClass(LavaPool.key, LavaPool);
registerThingClass(WaterTile.key, WaterTile);
registerThingClass(Chasm.key, Chasm);
registerThingClass(FireTower.key, FireTower);
registerThingClass(BloodPool.key, BloodPool);

// Mobs
registerThingClass(Robot.key, Robot);
registerThingClass(CaveRobot.key, CaveRobot);
registerThingClass(MiningRobot.key, MiningRobot);
registerThingClass(FloatingRobot.key, FloatingRobot);
registerThingClass(JetpackMob.key, JetpackMob);
registerThingClass(DummyMob.key, DummyMob);
registerThingClass(DummyMobB.key, DummyMobB);
registerThingClass(Squid.key, Squid);
registerThingClass(Horned.key, Horned);
registerThingClass(Slugant.key, Slugant);
registerThingClass(ToxicSlug.key, ToxicSlug);
registerThingClass(Amoeba.key, Amoeba);
registerThingClass(BigSquid.key, BigSquid);
registerThingClass(ArtilleryRobot.key, ArtilleryRobot);
registerThingClass(PlowRobot.key, PlowRobot);
registerThingClass(BossPlowRobot.key, BossPlowRobot);
registerThingClass(BlackHoleRobot.key, BlackHoleRobot);
registerThingClass(Player.key, Player);

// Terminals
registerThingClass(OpenBlastDoorsTerminal.key, OpenBlastDoorsTerminal);
registerThingClass(PowerPlantGateTerminal.key, PowerPlantGateTerminal);
registerThingClass(RobotEntranceTerminal.key, RobotEntranceTerminal);
registerThingClass(WinConditionTerminal.key, WinConditionTerminal);
registerThingClass(ZooReleaseTerminal.key, ZooReleaseTerminal);

// Level changers
registerThingClass(Downstairs.key, Downstairs);
registerThingClass(Upstairs.key, Upstairs);
registerThingClass(LadderDown.key, LadderDown);

// Spawners/Traps
registerThingClass(RobotSpawner.key, RobotSpawner);
registerThingClass(OpenBlastDoorsTrap.key, OpenBlastDoorsTrap);
registerThingClass(ActivateRobotSpawnersTrap.key, ActivateRobotSpawnersTrap);
registerThingClass(Tripwire.key, Tripwire);

// Multi-tile
registerThingClass(BigContainer.key, BigContainer);

// Other
registerThingClass(Sign.key, Sign);
registerThingClass(ScrapMetal.key, ScrapMetal);
registerThingClass(BlackBox.key, BlackBox);
registerThingClass(Landmine.key, Landmine);
registerThingClass(Text.key, Text);
registerThingClass(MapMarker.key, MapMarker);
